import isoFormat from './isoFormat'
import noop from './noop'
import createLogStore from './logStore'

const levels = Object.freeze({
  NONE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
  V1: 5,
})

const DEFAULT_LOG_LEVEL = process.env.NODE_ENV === 'development' ? levels.DEBUG : levels.INFO

let currentLogLevel = DEFAULT_LOG_LEVEL
let shouldCaptureLogs = false
const logStore = createLogStore()

const getSavedLogs = () => logStore.logs

const getClassString = className => (className ? `[${className}]` : '')

/*
 * className is optional
 * _Date is optional. Mostly it's for DI during testing.
 */
function createLogger(className, _Date = Date) {
  const getConsoleFunction =
    consoleFunction => console[consoleFunction]
      .bind(
        console,
        `%c${isoFormat(new _Date())} %c${getClassString(className)}`,
        'color: #BDC3C7', 'font-weight: bold',
      )

  const capture = _log => (message, ...args) => {
    let fullMessage = `${isoFormat(new _Date())} ${getClassString(className)}`

    if (message.toLowerCase) {
      fullMessage = `${fullMessage} ${message}`
    }

    logStore.add(fullMessage)
    logStore.add(args)

    _log(message, ...args)
  }


  function log(level, consoleFunction) {
    if (currentLogLevel < level) {
      return noop
    }

    if (!shouldCaptureLogs) {
      return getConsoleFunction(consoleFunction)
    }

    return capture(getConsoleFunction(consoleFunction))
  }

  const logger = {
    levels,

    getSavedLogs,

    set captureLogs(captureLogs) {
      shouldCaptureLogs = captureLogs

      if (shouldCaptureLogs) {
        logStore.loadStoredLogs()
      } else if (!shouldCaptureLogs) {
        logStore.stopStoring()
      }
    },

    set storageKey(newKey) {
      logStore.storageKey = newKey
    },

    set storageFrequency(newFrequency) {
      logStore.storageFrequency = newFrequency
    },

    get captureLogs() {
      return shouldCaptureLogs
    },

    get logLevel() {
      return currentLogLevel
    },

    set logLevel(level) {
      currentLogLevel = level
    },

    get error() {
      return log(levels.ERROR, 'error')
    },

    get warn() {
      return log(levels.WARN, 'warn')
    },

    get info() {
      return log(levels.INFO, 'info')
    },

    get log() {
      return log(levels.DEBUG, 'debug')
    },

    get debug() {
      return log(levels.DEBUG, 'debug')
    },

    get V1() {
      return log(levels.V1, 'debug')
    },
  }

  return logger
}

const globalLogger = createLogger()

export {
  createLogger,
}

export default globalLogger
